const deploymentFromWire = value => ({
  ...value,
  deploymentName: value?.deployment_name,
  modelProvider: value?.model_provider,
  apiEndpoint: value?.api_endpoint,
  modelName: value?.model_name,
  modelVersion: value?.model_version,
  provisioningState: value?.provisioning_state,
  organization: {
    organizationName: value?.organization?.organization_name,
    countryCode: value?.organization?.country_code,
    industry: value?.organization?.industry,
  },
  marketplaceTermsStatus: value?.marketplace_terms_status,
});

const accountFromWire = value => ({
  ...value,
  resourceGroup: value?.resource_group,
  provisioningState: value?.provisioning_state,
  keyAuthenticationDisabled: value?.key_authentication_disabled === true,
  projectsStatus: value?.projects_status,
  projects: Array.isArray(value?.projects) ? value.projects.map(project => ({
    ...project, provisioningState: project?.provisioning_state, isDefault: project?.is_default === true,
  })) : [],
  deployments: Array.isArray(value?.deployments) ? value.deployments.map(deploymentFromWire) : [],
});

export function foundryInventoryFromWire(value) {
  return {
    ...value,
    connectionId: value?.connection_id,
    accounts: Array.isArray(value?.accounts) ? value.accounts.map(accountFromWire) : value?.accounts,
  };
}

export function foundryCatalogFromWire(value) {
  return {
    ...value,
    accountId: value?.account_id,
    checkedAt: value?.checked_at,
    quotaReadAvailable: value?.quota_read_available,
    models: Array.isArray(value?.models) ? value.models.map(model => ({
      ...model,
      lifecycleStatus: model?.lifecycle_status,
      inferenceDeprecation: model?.inference_deprecation,
      skus: Array.isArray(model?.skus) ? model.skus.map(sku => ({
        ...sku,
        usageName: sku?.usage_name,
        deprecationDate: sku?.deprecation_date,
        capacity: {
          ...sku?.capacity,
          allowedValues: sku?.capacity?.allowed_values,
        },
      })) : [],
    })) : value?.models,
  };
}

export function foundryKeysFromWire(value) {
  return {
    ...value,
    accountId: value?.account_id,
    accountName: value?.account_name,
    keyName: value?.key_name,
  };
}

export function foundryModelConnectionFromWire(value) {
  return {
    ...value,
    modelId: value?.model_id,
    keyId: value?.key_id,
    modelString: value?.model_string,
    ownerType: value?.owner_type,
  };
}

export function foundrySetupToWire(value) {
  return {
    kind: value.kind,
    resource_group: value.resourceGroup,
    account_name: value.accountName,
    ...(value.location ? { location: value.location } : {}),
    ...(value.name ? { name: value.name } : {}),
    ...(value.model ? { model: value.model } : {}),
    ...(value.sku ? { sku: value.sku } : {}),
    ...(value.marketplace ? { marketplace: {
      accepted: value.marketplace.accepted,
      organization_name: value.marketplace.organizationName,
      country_code: value.marketplace.countryCode,
      industry: value.marketplace.industry,
    } } : {}),
  };
}

export function foundryModelConnectionToWire(value) {
  return {
    account_id: value.accountId,
    confirmation_name: value.confirmationName,
    deployment_name: value.deploymentName,
    model_type_id: value.modelTypeId,
  };
}
